module.exports = __webpack_public_path__ + "img/a3.02ae702b.png";